import { __awaiter } from "tslib";
/**
 * @ignore
 */
export function returnIterator(it) {
    if (typeof (it === null || it === void 0 ? void 0 : it.return) === 'function') {
        it.return();
    }
}
/**
 * @ignore
 */
export function returnAsyncIterator(it) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof (it === null || it === void 0 ? void 0 : it.return) === 'function') {
            yield it.return();
        }
    });
}

//# sourceMappingURL=returniterator.mjs.map
